const BASE = '/v1/step-execution';

export default (instance) => ({
  getQueue: (stationTypeId) => instance.get(`${BASE}/queue/${stationTypeId}`),
  getAvailableStations: (routeStepId) => instance.get(`${BASE}/available-stations`, { params: { routeStepId } }),
  startStep: (wipItemId, data) => instance.post(`${BASE}/start/${wipItemId}`, data),
  completeStep: (executionId, data) => instance.post(`${BASE}/complete/${executionId}`, data),
  getHistory: (wipItemId) => instance.get(`${BASE}/history/${wipItemId}`),
  getProcessingInfo: (executionId) => instance.get(`${BASE}/processing-info/${executionId}`),
  completeProcessingStep: (executionId, data) => instance.post(`${BASE}/complete-processing/${executionId}`, data),
  getMyActive: () => instance.get(`${BASE}/my-active`),
  getMaterials: (executionId) => instance.get(`${BASE}/${executionId}/materials`),
  getProductionPlanInfo: (wipItemId, routeStepId) => instance.get(`${BASE}/production-plan-info/${wipItemId}/${routeStepId}`)
});
